export default [
    {
        path:'/parent/home', component: () => import('@/views/parent/home')
    },
    {
        path:'/parent/link', component: () => import('@/views/parent/link')
    },
    {
        path:'/parent/request', component: () => import('@/views/parent/request')
    },
    {
        path:'/parent/announcement/:id', props: (route) => ({
            id:  Number(route.params.id)
        }), component: () => import('@/views/parent/announcement')
    },
    {
        path:'/parent/message', component: () => import('@/views/parent/message/detail')
    },
    {
        path:'/parent/application', component: () => import('@/views/parent/application')
    },
    {
        path:'/parent/application/:id/:type/view',props: (route) => ({
            id:  Number(route.params.id) ,type:  Number(route.params.type)
        }), component: () => import('@/views/parent/application/view')
    },
    {
        path:'/parent/message/:applicationId', props: (route) => ({
            applicationId:  Number(route.params.applicationId)
        }), component: () => import('@/views/parent/message/detail')
    },
    // {
    //     path:'/parent/application/:eventStatusId/:type/detail/:isEdit', props: (route) => ({
    //         isEdit: JSON.parse(route.params.isEdit),   eventStatusId:  Number(route.params.eventStatusId) ,type:  Number(route.params.type)}), component: () => import('@/views/parent/application/detail')
    // },
    {
        path:'/parent/application/:eventStatusId/:formType/add', props: (route) => ({
               eventStatusId:  Number(route.params.eventStatusId) ,formType:  Number(route.params.formType)}), component: () => import('@/views/parent/application/add')
    },
    {
        path:'/parent/application/:applicationId/:formType/edit', props: (route) => ({
            applicationId:  Number(route.params.applicationId) ,formType:  Number(route.params.formType)}), component: () => import('@/views/parent/application/edit')
    },
    {
        path:'/parent/account', component: () => import('@/views/parent/account')
    },
    {
        path:'/parent/request/:id/edit',  props: (route) => ({
            id:  Number(route.params.id)
        }), component: () => import('@/views/parent/request/edit')
    },
    {
        path:'/parent/uploadReceipt/:id',  props: (route) => ({
            id:  Number(route.params.id)
        }), component: () => import('@/views/parent/upload-receipt')
    },
]